export default "__VITE_ASSET__BqvjE6VJ__"